module.exports = __webpack_public_path__ + "img/next-arrow.d716278e.svg";